// TODO: Convert to uppercase because these are constants params

export const emailRegExp = /^([\w-/.]+@([\w-]+\.)+[\w-]{2,4})?$/;

export const phoneRegExp = /^(\d{7}|\d{8}|\d{9})$/;
// Accepts digits with optional + country code, separators: spaces, hyphens, dots, parentheses.
// e.g. "03-9688866", "+972-3-9688866", "(03) 968 8866"
export const INTERNATIONAL_PHONE_REGEX = /^[+]?[\d][\d\s\-().]{5,29}$/;

/** Digits only, at least one. Also used in SQL through `.source` (nationalIdMatchSql),
 *  so keep it valid as a Postgres `~` pattern too. */
export const ONLY_DIGITS_REGEX = /^[0-9]+$/;

// const passwordRegExp = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,20}$/;
/**
 * new regex by product request
 * 6-10 characters
 * At least 1 number (0-9)
 * At least 1 letter (a-z / A-Z)
 * At least 1 special character (@,#,$,%,^,&,)
 */
// export const passwordRegExp = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[@#$%^&]).{6,10}$/;
export const PASSWORD_REG_EXP = /^(?=.*\d)(?=.*[a-zA-Z]).{4,10}$/;

export const validateEmail = (email: string | undefined) => email && emailRegExp.test(email);

// export function checkHex(color: string) {
//     return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(color);
// }

/**
 * Matches a digit that is followed by one or more groups of exactly
 * three digits until the end of the string.
 *
 * Used to insert thousands separators with:
 * `.replace(THOUSANDS_SEPARATOR_REGEX, '$1,')`
 *
 * Example:
 * "1234567" -> "1,234,567"
 */
export const THOUSANDS_SEPARATOR_REGEX: RegExp = /(\d)(?=(\d{3})+(?!\d))/g;
